import { defineStore } from 'pinia';

export const useInventoryStore = defineStore({
	id: 'inventory',

	state: () => ({
		trigger_find_inventory_changes: false,
		trigger_sync_inventory_changes: false,
	}),

	actions: {
		setTriggerFindInventoryChanges() {
			this.trigger_find_inventory_changes = !this.trigger_find_inventory_changes;
		},
		setTriggerSyncInventoryChanges(value) {
			if (value == undefined) {
				value = true;
			}
			this.trigger_sync_inventory_changes = value;
		},
	},
});
